<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
      <v-flex xs12>
        <v-btn fab x-small @click="$router.go(-1)">
          <v-icon>navigate_before</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 md1 class="mb-2">
        <v-btn
          fab
          small
          @click="printTable()"
          class="ml-8 white--text"
          color="#2b6993"
          elevation="4"
          absolute
          right
        >
          <v-icon>print</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <h3 class="text-center mb-5">Staff Reimbursement Report</h3>
        <v-divider class="ml-4 mr-4 mb-3"></v-divider>
      </v-flex>

      <v-flex xs12>
        <v-card class="ma-3 pa-3" elevation="0">
          <v-layout row wrap>
            <v-flex xs12 md2 class="pa-1">
              <v-menu
                ref="calendarMenu"
                v-model="calendarMenu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportFilters.startDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="requiredField"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.startDate"
                  no-title
                  scrollable
                  :rules="requiredField"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="calendarMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.calendarMenu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md2 class="pa-1">
              <v-menu
                ref="calendar2Menu"
                v-model="calendar2Menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportFilters.endDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="requiredField"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.endDate"
                  no-title
                  scrollable
                  :rules="requiredField"
                  :min="minEndDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="calendar2Menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.calendar2Menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md2 class="pa-1 mb-2">
              <v-select
                label="Staff Status"
                :items="staffStatuses"
                v-model="reportFilters.staffStatus"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 md3 class="pa-1 mb-2">
              <v-select
                label="Select Staff"
                :items="filteredEmployees"
                item-text="Name"
                item-value="_id"
                v-model="reportFilters.StaffID"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 md2 class="pa-1 mb-2" v-show="showState">
              <v-select
                label="Select state"
                :items="States"
                item-text="State"
                item-value="State"
                v-model="filterState"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
              <v-btn @click="expenseQuery()">Search</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-2">
        <v-data-table
          :headers="headers"
          :items="expenses"
          sort-by="Date"
          sort-asc
          class="elevation-1"
          :loading="isLoading"
          loading-text="Loading Expenses"
          :items-per-page="100"
        >
          <template v-slot:item.select="{ item }">
            <v-btn
              x-small
              class="white--text"
              color="#2b3990"
              @click="viewReimbursement(item)"
            >
              view
            </v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <div id="print">
      <report-header>
        <h2>Staff Reimbursement Report</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="expenses"
            sort-by="Date"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Expenses"
            :items-per-page="-1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import Foot from '../components/Footer'
import { ROLES as Roles} from "@/enums/RolesEnum";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {
  STATUS_ARRAY,
  STATUSES as UserStatus
} from "../../enums/UserStatusEnum";
import { STATUSES as StaffStatus } from "../../enums/StaffStatusEnum";
import ReportFilters from '@/mixins/reportFilters.js';
import DateTimeUtil from "../../../utils/date-time.util";

const url = require("../../client_config/config").url;

export default {
  mixins: [
    ReportFilters,
  ],
  components: {
    ReportHeader
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Staff", value: "EmployeeID.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Type", value: "Type" },
      { text: "Employee Signature", value: "EnteredBy" },
      { text: "Status", value: "Status" },
      { text: "", value: "select" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    employees: [],
    expenses: [],
    dialog: false,
    startDate: "",
    endDate: "",
    StaffID: "",
    calendarMenu: false,
    calendar2Menu: false,
    report: "",
    clientName: "",
    isLoading: false,
    requiredField: [(v) => !!v || "This is required"],
    userState: localStorage.getItem('userState'),
    type: ["Cash", "Debit Card", "Deposit"],
    titleForm: "New Reimbursement",
    reimbursementID: "",
    newDate: "",
    newAmount: "",
    newType: "",
    newCategory: "",
    newOther: "",
    newPayee: "",
    newBalance: "",
    newDescription: "",
    newReceipt: [],
    category: ["Client Purchase", "Mileage", "Reimbursement", "Other"],
    newEnteredBy: "",
    newManager: "",
    editReimbursement: false,
    newReimbursement: false,
    checkManagerSignature: false,
    checkSignature: false,
    managerSigned: false,
    newSignature: "",
    newManagerSignature: "",
    status: "Outstanding",
    staff: localStorage.getItem("Name"),
    msg: false,
    text: "",
    AWSLink: "",
    filterState: "",
    States: ["Utah", "Nevada"],
    staffStatus: "",
    staffStatuses: STATUS_ARRAY,
    reportFilters:  {
      startDate: '',
      endDate: '',
      StaffID: '',
      staffStatus: '',
    },
    reportFilterName: 'ReportFilters_StaffExpenses',
    state: localStorage.getItem("userState"),
  }),

  computed: {
    minEndDate() {
      return this.reportFilters.startDate ? this.reportFilters.startDate : null;
    },
    showState() {
      if (
        // this.$store.state.users.userRole === Roles.ADMINISTRATION ||
        this.$store.state.users.userRole === Roles.SUPER_ADMINISTRATOR
      ) {
        return true;
      }
      return false;
    },

    filteredEmployees() {
      const employees = this.employees;

      if (this.reportFilters.staffStatus === UserStatus.INACTIVE) {
        return employees.filter(
          (employee) => employee.Status == StaffStatus.TERMINATED
        );
      }

      if (this.reportFilters.staffStatus === UserStatus.ACTIVE) {
        return employees.filter(
          (employee) =>
            employee.Status == StaffStatus.FULL_TIME ||
            employee.Status == StaffStatus.PART_TIME
        );
      }
      return employees;
    },
  },

  created() {
    this.getEmployees();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },

  watch: {
    reportFilters: {
      handler(newVal) {
        this.setReportFilters(this.reportFilterName, newVal);
      },
      deep: true
    }
  },
  methods: {
    initialize() {
      this.tests = [];
    },

    getEmployees() {
        let endpoint = "";
        const companyIds = localStorage.getItem("userCompanies");

        endpoint = `${url}/users/getAll/users/${this.state}`;

        axios
            .get(endpoint, {
                params: {
                    Company: JSON.parse(companyIds),
                },
            })
            .then((res) => {
                this.employees = res.data.users;
            });
    },

    expenseQuery() {
      this.expenses = [];
      this.isLoading = true;
      this.userState = this.userState || '';


      const companyIds = localStorage.getItem("userCompanies");
      let endpoint = "";
      let filterData = {
        staffID: this.reportFilters.StaffID,
        startDate: this.reportFilters.startDate,
        endDate: this.reportFilters.endDate,
        Company: JSON.parse(companyIds),
        State: this.userState,
        staffStatus: this.reportFilters.staffStatus,
      };

      endpoint = `${url}/reimbursements/`;

      axios
        .get(endpoint, {
          params: filterData,
        })
        .then((res) => {
            const staffReimbursements = res.data.reimbursements;

            staffReimbursements.map(staffReimbursement => {
                staffReimbursement.Date = DateTimeUtil.toLocalDate(staffReimbursement.Date)
            })
            
          this.expenses = staffReimbursements;
          this.isLoading = false;
        });
    },

    getStaffID(item) {
      this.staff = item.EmployeeID;
      window.localStorage.setItem("staffId", this.staff);
      console.log(this.staff);
    },

    viewReimbursement(item) {
        this.$router.push({
            path: `/staffExpenses/view/${item._id}`,
            query: {viewingReimbursement: true}
        })
    },

    printTable() {
      window.print();
    },

  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
